import { useState } from "react";
import { useData } from "./DataContext.js";

import Card from "react-bootstrap/Card";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Popover from "react-bootstrap/Popover";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Badge from "react-bootstrap/Badge";

import Markdown from "react-markdown";

import CharPicture from "./CharPicture.js";
import SolutionTitle from "./SolutionTitle.js";

export default function CharCard (props)
{
    const gData = useData();

    const [hover, setHover] = useState(false);

    let charContent = gData.content.chars[props.charId];
    if (props.charId === null) charContent = { color: "#e2e3e5", firstName: "Inconnu", lastName: "", title: "", placeId: null };

    const anyChoiceQuestNb = Object.values(gData.state.choiceQuests).filter((quest) => quest.charId === charContent.id && quest.themeId === gData.state.currentThemeId).length;
    const opened = props.charId !== null && (! gData.content.params.choiceQuests || anyChoiceQuestNb > 0 || props.charId === "directeur");
    let bgColor = charContent.color;

    /* let confront = gData.state.items["indice_1"].found && gData.state.items["indice_2"].found && gData.state.items["indice_3"].found; */

    let popover = (<></>);
    let placement = "auto";
    let cardTitle = (<></>);
    let cardBadge = (<></>);
    
    switch (gData.gameId)
    {
	case "2cpo" :
	{
	    let questNb = 0;
	    let newSolutionIds = [];
	    let solutionIds = [];

	    Object.values(gData.state.choiceQuests)
		  .filter((quest) => quest.charId === charContent.id && quest.themeId === gData.state.currentThemeId && quest.state === "opened")
		  .forEach((quest) => {
		      questNb++;
		      quest.itemIds.forEach((itemId) => {
			  if (gData.content.solutions[itemId] !== undefined && ! newSolutionIds.includes(itemId)) newSolutionIds.push(itemId);
			  if (gData.content.documents[itemId] !== undefined)
			  {
			      const solutionId = gData.content.documents[itemId].solutionId;
			      if (! solutionIds.includes(solutionId) && gData.state.solutions[solutionId].found) solutionIds.push(solutionId);
			  }
		      });
		  });

	    const newSolutionTitles = newSolutionIds.map((solutionId) => (<SolutionTitle key={solutionId} solutionId={solutionId} newSolution={true} simple={true}/>));
	    const solutionTitles = solutionIds.map((solutionId) => (<SolutionTitle key={solutionId} solutionId={solutionId} simple={true}/>));
	    
	    cardTitle = (<span className=" fs-7 lh-sm">{charContent.title}</span>);
	    if (questNb > 0) cardBadge = (<Badge bg="dark" className="fs-5 position-absolute top-0 end-0 m-2">{questNb}</Badge>);

	    popover = (
		<Popover className="popover-lg shadow" style={{ borderColor: bgColor }}>
		    <Popover.Header  style={{ backgroundColor: bgColor, borderColor: bgColor }}>
			<div className="d-flex flex-column align-items-start">
			    <div className="w-100 d-flex justify-content-between align-items-start">
				<div className="fs-5">{charContent.firstName} <span className="text-uppercase">{charContent.lastName}</span></div>
				{/* <div>{questNb > 0 && (<Badge bg="dark" className="fs-6">{questNb} question{questNb > 1 ? "s" : ""}</Badge>)}</div> */}
			    </div>
			    <div className="fs-5 fw-medium">{charContent.title}</div>
			</div>
		    </Popover.Header>
		    {(newSolutionTitles.length > 0 || solutionTitles.length > 0) && (
			<Popover.Body>
			    <p className="fs-6 text-center mx-5">{charContent.firstName} {charContent.lastName} souhaite notamment vous parler des solutions suivantes&nbsp;:</p>
			    <div className="d-flex flex-column align-items-center gap-2">
				{newSolutionTitles}{solutionTitles}
			    </div>
			</Popover.Body>
		    )}
		</Popover>
	    );
	}
	break;
	
	case "ada" :
	{
	    cardTitle = (<div className={" fs-7 lh-sm fw-medium text-uppercase " + (props.charId === null ? "text-secondary" : "") + (hover && props.charId !== null ? "fw-bold" : "")}>{hover && props.charId !== null ? "Interroger" : charContent.firstName}</div>);

	    if (props.charId !== null)
	    {
		let placeTitle = gData.content.places[charContent.placeId].title;

		let problemContent = "Aucun";
		let problemClassNames = "";

		if (gData.state.badges["solution_"+props.charId] !== undefined && gData.state.badges["solution_"+props.charId].state === "opened")
		{
		    problemContent = charContent.closedProblem;
		    problemClassNames = "text-success ";
		}
		
		else if (gData.state.badges["probleme_"+props.charId] !== undefined && gData.state.badges["probleme_"+props.charId].state === "opened")
		{
		    problemContent = charContent.openedProblem;
		    problemClassNames = "text-danger ";
		}
		
		else if (props.charId === "leonie" || props.charId === "dounia" || props.charId === "axel")
		{
		    problemContent = "Inconnu";
		    problemClassNames = "text-danger ";
		}
		
		placement = "right";
		popover = (
		    <Popover className="popover-lg shadow" style={{ borderColor: bgColor }}>
			<Popover.Header  style={{ backgroundColor: bgColor, borderColor: bgColor }} className="d-flex align-items-center justify-content-between">
			    <div className="fs-4">{charContent.firstName} <span className="text-uppercase">{charContent.lastName}</span></div>
			    <div className="fs-5"></div>
			</Popover.Header>
			<Popover.Body>
			    <span className="fs-5">
				<Row className="mb-2">
				    <Col md={3} className="text-uppercase small">Poste</Col>
				    <Col md={9}>{charContent.title}</Col>
				</Row>
				<Row className="mb-2">
				    <Col md={3} className="text-uppercase small">Lieu</Col>
				    <Col md={9}>{placeTitle}</Col>
				</Row>
				{charContent.openedProblem !== "" && (
				    <Row>
					<Col md={3} className={"text-uppercase small " + problemClassNames}>Problème</Col>
					<Col md={9} className={problemClassNames}><Markdown components={{ p: "span" }}>{problemContent}</Markdown></Col>
				    </Row>
				)}
			    </span>
			</Popover.Body>
		    </Popover>
		);
	    }
	}
	break;

	default:
    }
	
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(bgColor);
    const r = parseInt(result[1], 16);
    const g = parseInt(result[2], 16);
    const b = parseInt(result[3], 16);

    const pictureWidth = props.pictureWidth === undefined ? "auto" : props.pictureWidth;
    const pictureHeight = props.pictureHeight === undefined ? "auto" : props.pictureHeight;
    const pictureMargin = props.pictureMargin === undefined ? "none" : props.pictureMargin;

    return (
	<OverlayTrigger placement={placement} overlay={opened ? popover : (<></>)}>
	    <Card className={"h-100 d-flex flex-column user-select-none " + (opened ? "" : "opacity-50")} role={opened ? "button" : ""} style={{ borderColor: bgColor }}
		  onMouseEnter={() => { setHover(true); }} onMouseLeave={() => { setHover(false); }}
	    >
		<Card.Body className="flex-shrink-1 p-0 m-0" style={{ backgroundColor: (opened && hover && props.charId !== null ? "rgba("+r+", "+g+", "+b+", 0.25)" : "") }}>
		    {cardBadge}
		    <CharPicture charId={props.charId} width={pictureWidth} height={pictureHeight} margin={pictureMargin}/>
		</Card.Body>
		<Card.Header className={"h-100 d-flex justify-content-center align-items-center text-center"} style={{ backgroundColor: bgColor, borderColor: bgColor }}>
		    {cardTitle}
		</Card.Header>
	    </Card>
	</OverlayTrigger>
    );
}
